export default __webpack_public_path__ + "static/media/menu_top_recordings.15c058fa.svg";